import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Label } from '@/components/ui/label';

import { cn } from '@/lib/utils';

import { useDateRangePicker, type DateRangeValue } from '../model/use-date-range-picker';
import { DateRangeTrigger } from './date-range-trigger';
import { PresetSidebar } from './preset-sidebar';
import { CalendarSection } from './calendar-section';

interface DateRangePickerProps {
  label?: string;
  defaultPreset?: string;
  defaultFromDate?: string;
  defaultToDate?: string;
  onChange?: (value: DateRangeValue) => void;
  className?: string;
}

export function DateRangePicker({
  label,
  defaultPreset = 'L6M',
  defaultFromDate,
  defaultToDate,
  onChange,
  className
}: DateRangePickerProps) {
  const {
    open,
    dateRange,
    selectedPreset,
    presetRanges,
    setOpen,
    handleRangeChange,
    handlePresetSelect,
    handleCancel,
    handleApply
  } = useDateRangePicker({
    defaultPreset,
    defaultFromDate,
    defaultToDate,
    onChange
  });

  return (
    <div className={cn('flex flex-col gap-2', className)}>
      {label && <Label>{label}</Label>}
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <DateRangeTrigger dateRange={dateRange} />
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0 max-w-[calc(100vw-2rem)] sm:max-w-none" align="start">
          <div className="flex flex-col sm:flex-row max-h-[calc(100vh-8rem)] overflow-y-auto sm:max-h-none sm:overflow-visible">
            <PresetSidebar
              presetRanges={presetRanges}
              selectedPreset={selectedPreset}
              onPresetSelect={handlePresetSelect}
            />
            <CalendarSection
              dateRange={dateRange}
              onRangeChange={handleRangeChange}
              handleCancel={handleCancel}
              handleApply={handleApply}
            />
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
}
